import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Form, Input, Checkbox, Button,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';

const styles = {
  section: {
    fontSize: '80%',
    fontWeight: 'bold',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    margin: '0 0 8px',
  },
  group: { marginTop: '18px' },
  hint: {
    fontSize: '80%', color: '#999', margin: '2px 0 0 26px',
  },
  clear: { marginTop: '18px' },
};

const SORT_OPTIONS = [
  { key: 'newest', text: 'Newest first', value: 'newest' },
  { key: 'oldest', text: 'Oldest first', value: 'oldest' },
];

const calendarInput = id => <Input id={id} fluid icon="calendar outline" iconPosition="left" />;

// Every control refetches page 1 server-side (parent handlers) — no Apply button.
const StoryFilters = ({
  startDate, endDate, matchedOnly, sortNewest,
  onStartChange, onEndChange, onToggleMatched, onSortChange, onClear,
}) => (
  <Form>
    <div style={styles.section}>Date range</div>
    <Form.Field>
      <label htmlFor="stories-from">Posted after</label>
      <DatePicker
        selected={startDate}
        onChange={onStartChange}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        maxDate={endDate || moment()}
        dateFormat="YYYY-MM-DD"
        placeholderText="Any date"
        customInput={calendarInput('stories-from')}
      />
    </Form.Field>
    <Form.Field>
      <label htmlFor="stories-to">Posted before</label>
      <DatePicker
        selected={endDate}
        onChange={onEndChange}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        maxDate={moment()}
        dateFormat="YYYY-MM-DD"
        placeholderText="Any date"
        customInput={calendarInput('stories-to')}
      />
    </Form.Field>

    <div style={styles.group}>
      <div style={styles.section}>Sort by</div>
      <Form.Select
        fluid
        options={SORT_OPTIONS}
        value={sortNewest ? 'newest' : 'oldest'}
        onChange={onSortChange}
      />
    </div>

    <div style={styles.group}>
      <div style={styles.section}>Show</div>
      <Checkbox label="Only matched stories" checked={matchedOnly} onChange={onToggleMatched} />
      <div style={styles.hint}>Hide posts that did not match the campaign.</div>
    </div>

    <Button basic fluid size="tiny" style={styles.clear} onClick={onClear}>Clear filters</Button>
  </Form>
);

StoryFilters.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  matchedOnly: PropTypes.bool.isRequired,
  sortNewest: PropTypes.bool.isRequired,
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
  onToggleMatched: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

StoryFilters.defaultProps = {
  startDate: null,
  endDate: null,
};

export default StoryFilters;



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/StoryFilters.js
 **/